import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 86 85" {...props}>
    <g fill="none" fillRule="evenodd" transform="rotate(-8 77.664 .544)">
      <path fill="#7BB835" d="M74.762 7.607L80 13.84l-5.238 6.232v54.64H0V0h74.762v7.607z" />
      <text x="5" y="28" fill="#fff" style={{fontSize: 20}}>
        第一单
      </text>
      <text x="12" y="60" fill="#fff" style={{fontSize: 25}}>
        免费
      </text>
    </g>
  </Svg>
)
